import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class OilFieldDto extends EpimsBaseEntityDto {
	@IsNotEmpty() OilFieldId: string;
	@IsNotEmpty() OilFieldName: string;
	@IsNotEmpty() LabelName: string;
	@IsNotEmpty() OilBlockId: string;
}
